<template>
  <section>
    <div class="is-flex is-flex-direction-column">
      <div
        class="is-flex is-flex-direction-row is-align-item-center is-justify-content-space-between"
      >
        <span
          class="is-uppercase has-text-weight-semibold has-text-grey"
          :data-e2e="AnnouncementCypressAttribute.views.ANNOUNCEMENT_RELEASE_DATE"
        >
          {{ announcement.formattedReleaseDate }}
        </span>
        <div v-if="canClose">
          <i
            class="cls cls-remove is-clickable is-pulled-right"
            :data-e2e="AnnouncementCypressAttribute.buttons.ANNOUNCEMENT_CLOSE_BUTTON"
            @click="onClose"
          />
        </div>
      </div>
      <span
        class="has-text-weight-medium is-size-3"
        :data-e2e="AnnouncementCypressAttribute.views.ANNOUNCEMENT_TITLE"
      >
        {{ announcement.title }}
      </span>
    </div>

    <AnnouncementJurisdictionTags class="mt-2" :announcement="announcement" />

    <div class="description-container">
      <p
        class="m-t-10 announcement-description"
        :class="{
          'has-content has-multiline-ellipsis-2': announcement.contentType,
          'is-minified has-multiline-ellipsis-8': !isExpanded
        }"
        style="white-space: pre-line"
        v-dompurify-html="description"
        :data-e2e="AnnouncementCypressAttribute.views.ANNOUNCEMENT_DESCRIPTION"
      ></p>
      <div
        class="m-t-5"
        v-if="announcement.contentType"
        :data-e2e="AnnouncementCypressAttribute.views.ANNOUNCEMENT_CONTENT_SOURCE"
      >
        <iframe
          v-if="announcement.contentType === AnnouncementContentType.SCRIBE.key"
          :src="announcement.contentSourceUrl"
          width="100%"
          height="750px"
        ></iframe>
        <img
          v-else
          class="m-t-5"
          alt="Announcement visual description"
          :src="announcement.contentSourceUrl"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { AnnouncementContentType } from '@/modules/announcement/constants/AnnouncementContentType';
import AnnouncementJurisdictionTags from '@/modules/announcement/components/presentational/AnnouncementJurisdictionTags.vue';
import { AnnouncementCypressAttribute } from '@/modules/announcement/constants/AnnouncementCypressAttribute';
import { markdownToHtml } from '@/modules/core/app/helpers/StringHelper';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'InAppAnnouncementDetails',
  emits: ['close'],
  components: {
    AnnouncementJurisdictionTags
  },
  props: {
    announcement: {
      type: Object,
      required: true
    },
    isExpanded: {
      type: Boolean,
      default: false
    },
    canClose: {
      type: Boolean,
      default: false
    }
  },
  static: {
    AnnouncementContentType,
    AnnouncementCypressAttribute
  },
  computed: {
    description() {
      return markdownToHtml(this.announcement.description);
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.announcement-description {
  font-size: var(--ce-17px);
  hyphens: auto;
}

.announcement-description :deep(ul) {
  list-style: disc;
  padding: var(--ce-20px);
}
.announcement-description :deep(ol) {
  list-style: decimal;
  padding: var(--ce-20px);
}

.announcement-description.is-minified {
  font-size: var(--ce-14px);
  white-space: normal;
}

.announcement-description.is-minified.has-content {
  white-space: normal;
}
</style>
